import { Card } from '@radix-ui/themes';

import * as Types from '../../../../types';
import { NodeContextMenu } from '../../ContextMenu';
import { WorkflowNodeProps } from '..';

import { DefaultNode, BlockNode, TransactionNode } from './types';

const signalNodeComponentMap: Record<
  'default' | Types.SignalType,
  React.ComponentType<any>
> = {
  default: DefaultNode,
  [Types.SignalType.Address]: DefaultNode, // TODO: Create Address-specific component
  [Types.SignalType.Block]: BlockNode,
  [Types.SignalType.Contract]: DefaultNode, // TODO: Create Contract-specific component
  [Types.SignalType.Network]: DefaultNode, // TODO: Create Network-specific component
  [Types.SignalType.Transaction]: TransactionNode,
};

const SignalNode = (props: WorkflowNodeProps<Types.SignalNode>) => {
  const { id, data, onDelete } = props;
  // Use default node component if signalType is not set
  const NodeComponent = data.signal.signalType
    ? signalNodeComponentMap[data.signal.signalType]
    : signalNodeComponentMap.default;

  if (!NodeComponent) {
    return (
      <NodeContextMenu onDelete={() => onDelete(id)}>
        <Card style={{ width: '300px', border: '1px dashed orange' }}>
          Unknown signal type: {data.signal.signalType}
        </Card>
      </NodeContextMenu>
    );
  }

  return (
    <NodeContextMenu onDelete={() => onDelete(id)}>
      <NodeComponent {...props} onCancel={() => onDelete(id)} />
    </NodeContextMenu>
  );
};

export default SignalNode;
